import { VerticalType } from "../products/products.enums";


enum BrandGuidelinesImageCategory {
  ProductImage = 0,
  Lifestyle = 1,
  Graphics = 2,
  BackgroundImage = 3,
}

enum AiBrandGuidelinesImageCategory {
  ProductImage = 'Product Image',
  Lifestyle = 'Lifestyle',
  Graphics = 'Graphics',
  BackgroundImage = 'Background Image',
}

interface BrandColor {
  name: string | null;
  color: string | null;
  purpose: string | null;
}

interface BrandColors {
  colors: BrandColor[] | null;
  colorUsageGuidelines: string[] | null;
}

interface BrandIdentity {
  brandName: string | null;
  brandDescription: string | null;
  brandPersona: string | null;
  brandValues: string[] | null;
  targetIndustry: VerticalType;
  usageContext: string | null;
}

interface ImageGuidelines {
  imageCategory: BrandGuidelinesImageCategory;
  guidelines: string[];
}

interface BrandVoiceGuidelines {
  toneOfVoice: string[];
  editorialGuidelines: string[];
  editorialRestrictions: string[];
  brandPhrases: string[];
  grammarAndStyle: string[];
}

interface BrandGuidelines {
  brandIdentity: BrandIdentity;
  brandVoiceGuidelines: BrandVoiceGuidelines;
  imageGuidelines: ImageGuidelines[] | null;
  colors: BrandColors;
}

interface Persona {
  id: number;
  name: string | null;
  avatarUrl: string | null;
  description: string | null;
  keyInterests: string[];
  painPoints: string[];
  resonatingMessages: string[];
  avoidances: string[];
  minAge: number | null;
  maxAge: number | null;
}

export {
  BrandGuidelinesImageCategory,
  AiBrandGuidelinesImageCategory,
  BrandColor,
  BrandColors,
  BrandIdentity,
  ImageGuidelines,
  BrandVoiceGuidelines,
  BrandGuidelines,
  Persona,
}; 